import React from 'react'
import memberList from '../Shared/TeamMembers'
import './Team.css'

const Team = () => {
    return (
        <>

            <section className='teamContainer mt-5 mb-5'>
                <div className='container'>
                    <div className="serviceCont">
                        <h1 style={{ width: '48%' }}> Meet Our Experts </h1>
                        <h6 style={{ marginTop: '1.2rem' }}> The Core Strength of Car Genie Kolkata </h6>
                    </div>
                    <h5>
                        At Car Genie Kolkata, we take pride in our team of industry-certified professionals who bring decades of expertise, precision, and passion to every vehicle they touch. Each of our experts represents the finest in their domain — combining years of hands-on experience with top-tier training from leading automotive brands.
                    </h5>
                    <div className='team'>
                        {/* Team member cards */}
                        <ul className="teamMemberList">
                            {memberList.map((items) => (
                                <li className="teamMemberCard">
                                    <div className="teamMemberImage">
                                        <img src={`images/${items.name}`} alt={items.title} title={items.title} />
                                    </div>
                                    <div className="teamMemberInfo">
                                        {items.memberDetails.map((detail) => (
                                            <>
                                                <h3>{detail.name}</h3>
                                                <h5>{detail.role}</h5>
                                                <p><strong> Experience:</strong> {detail.experience}</p>
                                                {detail.experienceDesc && <p> {detail.experienceDesc}</p>}
                                                {detail.education && <p><strong>Education:</strong> {detail.education}</p>}
                                                <p>{detail.summary}</p>
                                            </>
                                        ))}
                                    </div>
                                </li>
                            ))
                            }
                        </ul>

                        <div className='teamSlogan'>
                            <img src='images/certifiedRating.png' alt='carGenie' title='carGenie' />
                            <h2> Certified. Experienced. Trusted. </h2>
                        </div>

                        <h3 className='slogan'>
                            Every technician at Car Genie is certified by authentic automotive training institutes and brings years of professional experience from reputed automobile brands. Together, they form the powerhouse that makes Car Genie the most reliable and skilled multi-brand car service workshop in Kolkata and West Bengal.
                        </h3>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Team